var map = {
	"./Cantarei teu amor - Eli Soares.mp4": 226,
	"./Deixar a lágrima rolar - Bruna Karla.mp4": 735,
	"./Novo dia - GetWorship.mp4": 811,
	"./Sublime - FHOP.mp4": 641,
	"./Sweet child O'mine - Guns N Roses.mp4": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;